import classNames from "classnames";
import { useContext, useEffect, useState } from "react";
import { RouteComponentProps, useHistory } from "react-router-dom";

import Dropdown from "src/app/components/dropdown/Dropdown";
import { TARGET_GROUPS } from "src/app/modules/auth/constants";
import userCSS from "src/app/modules/user/User.module.css";
import { INPUT_TYPE, ROUTES } from "src/config/constants";
import { AuthContext } from "src/contexts/AuthContext";
import { ModalContext } from "src/contexts/ModalContext";
import { ApiResult } from "src/core/helpers/api/ApiResult";
import { AccountResponse } from "src/core/models/auth";
import { AccountsService } from "src/core/services/auth";

const Profile = ({ match }: RouteComponentProps) => {
  const { userId }: any = match.params;
  const authData = useContext(AuthContext);
  const modalData = useContext(ModalContext);

  const [stateUpdated, setStateUpdated] = useState(false);
  const [currentState, setFormData] = useState({
    firstName: authData?.auth?.firstName,
    lastName: authData?.auth?.lastName,
    phoneNumber: authData?.auth?.phoneNumber,
    targetGroup: TARGET_GROUPS.getValue(authData?.auth?.targetGroup),
  });

  let history = useHistory();

  useEffect(() => {
    if (currentState.firstName !== authData?.auth?.firstName) {
      setStateUpdated(true);
    } else if (currentState.lastName !== authData?.auth?.lastName) {
      setStateUpdated(true);
    } else if (currentState.targetGroup !== TARGET_GROUPS.getValue(authData?.auth?.targetGroup)) {
      setStateUpdated(true);
    } else if (currentState.phoneNumber !== authData?.auth?.phoneNumber) {
      setStateUpdated(true);
    } else {
      setStateUpdated(false);
    }
  }, [currentState, authData]);

  const onInputChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const inputType = event.target.type;
    const inputName = event.target.name;
    const inputValue = inputType === INPUT_TYPE.Checkbox ? event.target.checked : event.target.value;

    setFormData((currentState) => {
      return {
        ...currentState,
        [inputName]: inputValue,
      };
    });
  };

  function resetState() {
    setFormData({
      firstName: authData?.auth?.firstName,
      lastName: authData?.auth?.lastName,
      phoneNumber: authData?.auth?.phoneNumber,
      targetGroup: TARGET_GROUPS.getValue(authData?.auth?.targetGroup),
    });
  }

  const handleTargetGroupChange = (selectedTargetValue: number) => {
    setFormData((currentState) => {
      return {
        ...currentState,
        targetGroup: selectedTargetValue,
      };
    });
  };

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    AccountsService.update(userId, {
      firstName: currentState.firstName,
      lastName: currentState.lastName,
      email: authData?.auth?.email,
      phoneNumber: currentState.phoneNumber,
      targetGroup: TARGET_GROUPS.getText(currentState.targetGroup!),
      password: "",
      confirmPassword: "",
    })
      .then((response: AccountResponse) => {
        authData?.updateProfileData(response);
        modalData?.triggerSuccess({
          title: "Uspješno ažuriranje",
          message: "Uspješno ste ažurirali podatke profila",
        });
      })
      .catch((e: ApiResult) => {
        modalData?.triggerError(e);
      });
  };

  const changePassword = () => {
    const returnUrl = ROUTES.resetPassword;
    AccountsService.changePassword(returnUrl)
      .then((response: any) => {
        history.push(response.message);
      })
      .catch((e: ApiResult) => {
        modalData?.triggerError(e);
      });
  };

  return (
    <div className={classNames("u-bg-white", "u-col-xs-10", "u-col-sm-6", "u-col-md-4", "u-col-lg-4", userCSS.modalWrap)}>
      <h3 className="u-t-primary-dark u-t-uppercase">moj profil</h3>
      <form onSubmit={handleSubmit} className="u-col-xs-10 u-col-sm-9 u-col-md-9 u-col-lg-7">
        <label htmlFor="fName" className="u-t-f14p u-ml10px">
          Ime
        </label>
        <input value={currentState.firstName ?? ""} type="text" name="firstName" onChange={onInputChange} className="u-t-f15p u-mb10per" required />
        <label htmlFor="lName" className="u-t-f14p u-ml10px">
          Prezime
        </label>
        <input value={currentState.lastName ?? ""} type="text" name="lastName" onChange={onInputChange} className="u-t-f15p u-mb10per" required />
        <label htmlFor="company" className="u-t-f14p u-ml10px">
          Ciljna skupina
        </label>
        <Dropdown
          items={TARGET_GROUPS.values}
          activeItemValue={currentState.targetGroup}
          defaultItem={null}
          placeholder={"odaberi"}
          removePlaceholder={true}
          handleChange={handleTargetGroupChange}
          customCss={classNames("u-t-f16p u-mb0 u-mb10per")}
        />
        <label htmlFor="contact" className="u-t-f14p u-ml10px">
          Kontakt broj
        </label>
        <input value={currentState.phoneNumber ?? ""} type="text" name="phoneNumber" onChange={onInputChange} className="u-t-f15p u-mb10per" required />
        <button
          type="button"
          onClick={changePassword}
          className={classNames("u-cursor-pointer", "u-t-primary-dark", "u-t-f16p", "u-bg-background", "u-mb10per", "u-t-w400", userCSS.changePassBtn)}
        >
          Promjeni lozinku
        </button>
        <div className="u-mb10per">
          <button
            type="button"
            onClick={() => resetState()}
            className={classNames("u-cursor-pointer", "u-t-uppercase", stateUpdated ? "" : "u-hidden", userCSS.whiteFillBtn)}
          >
            odustani
          </button>
          <button type="submit" className={classNames("u-cursor-pointer", "u-t-uppercase", stateUpdated ? "" : "u-hidden", userCSS.blueFillBtn)}>
            spremi
          </button>
        </div>
      </form>
    </div>
  );
};

export default Profile;
